import { withGlobalSpinnerActionEnhancer } from '@Utils/Redux/withGlobalSpinnerActionEnhancer';
import { logAsyncError } from '@Utils/Decorators';
import { searchAlertResults } from '@Services/AlertResults';

import { selectResultOfAlertType } from './AlertItemConstants';

import { open as openAlertCreateDialog } from '../AlertCreateDialog/AlertCreateDialogActions';
import {
  alertsItem as alertsItemSelector,
  alertDatabaseId as alertDatabaseIdSelector,
  allDatabasesByGroupId as allDatabasesByGroupIdSelector,
} from '../../AlertsSelectors';

export function selectResultOfAlert(alertId, runId) {
  return {
    type: selectResultOfAlertType,
    payload: {
      alertId,
      runId,
    },
  };
}

export const fetchResultsInfo = withGlobalSpinnerActionEnhancer((alert, runId) =>
  logAsyncError(async () => {
    const params = {
      context: alert.getIn(['alertsItem', 'context']),
      alert: runId,
    };

    await searchAlertResults(params);
  })
);

export function openEditAlert(id) {
  return (dispatch, getState) => {
    const databaseId = alertDatabaseIdSelector(getState(), { id });
    const alertsItem = alertsItemSelector(getState(), { id });
    const groupId = alertsItem && alertsItem.get('groupId');
    const allDatabases = allDatabasesByGroupIdSelector(getState(), { groupId });

    dispatch(
      openAlertCreateDialog({
        alert:
          alertsItem &&
          alertsItem
            .merge({
              ...(allDatabases && { allDatabases }),
            })
            .toJS(),
        databaseId,
        mode: 'edit',
        onSuccess: () => {},
      })
    );
  };
}
